var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{staticClass:"closed-label"},[_vm._v("\n  已关闭\n")])}
var staticRenderFns = []

export { render, staticRenderFns }